import React from 'react';

function FastbetMatchSearchPopup(props) {
    return (
        <div id="autocomplete-search-results-id-fastbet" className="autocomplete-search-results-popup-fastbet" style={{display: 'none'}}>
        </div>
    )
}

export default FastbetMatchSearchPopup;